
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Moment } from 'moment-timezone';
import { AppointmentsTimeslot } from '@/types/AppointmentsQueue';
import { AppointmentSlot } from '@/types/Appointment';
import AppointmentCell from '@/components/appointments/AppointmentCell.vue';

@Component({
	components: {
		AppointmentCell,
	},
})
export default class AppointmentsColumn extends Vue {
	@Prop({ required: true }) appointments!: AppointmentSlot[];
	@Prop({ required: true }) index!: number;
	@Prop({ required: true }) time!: Moment;
	@Prop({ required: true }) timeslot!: AppointmentsTimeslot;
	@Prop({ required: true }) selected!: boolean;
	@Prop({ required: true }) admin!: boolean;

	hovering = false;
}
